(() => {
  const configElement = document.getElementById('EsmerallyPurchaseReviewConfig');
  if (!configElement || !document.body.hasAttribute('data-esmerally-purchase-review')) return;
  const config = JSON.parse(configElement.textContent);
  const spanish = config.locale === 'es' || config.locale.startsWith('es-');
  const productSelector = '[data-product-handle="esmerally-womens-pack"]';
  const textMap = new Map(Object.entries(config.translations));
  const normalize = (value) => value.replace(/\s+/g, ' ').trim();
  const translate = (root) => {
    if (!root || !spanish) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (node.parentElement.closest('script, style, textarea, #judgeme_product_reviews, .jdgm-carousel-wrapper')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const changes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      const current = normalize(node.nodeValue);
      const replacement = textMap.get(current);
      if (replacement && replacement !== current) changes.push([node, replacement]);
    }
    changes.forEach(([node, replacement]) => {
      const leading = node.nodeValue.match(/^\s*/)[0];
      const trailing = node.nodeValue.match(/\s*$/)[0];
      node.nodeValue = leading + replacement + trailing;
    });
    root.querySelectorAll('[aria-label]').forEach((element) => {
      const current = element.getAttribute('aria-label');
      const replacement = textMap.get(normalize(current));
      if (replacement && replacement !== current) element.setAttribute('aria-label', replacement);
    });
  };
  const sync = () => {
    observer.disconnect();
    document.querySelectorAll('#MainContent a[href^="/pages/esmerally-womens-packs"]').forEach((link) => {
      link.setAttribute('href', '/products/esmerally-womens-pack');
    });
    if (spanish) {
      [document.getElementById('MainContent'), document.getElementById('SiteHeader'), document.getElementById('shopify-section-footer'),
       document.getElementById('seal-loyalty-main-button-text'),
       document.querySelector('[id$="__17332068787184144230"]')].forEach(translate);
      document.querySelectorAll(productSelector + ' .sls-select').forEach((select) => {
        if (select.getAttribute('aria-label') !== config.intervalLabel) select.setAttribute('aria-label', config.intervalLabel);
      });
      const reviewsTitle = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg__title');
      if (reviewsTitle && reviewsTitle.textContent !== config.reviewsTitle) reviewsTitle.textContent = config.reviewsTitle;
      const sortLabel = document.querySelector('#judgeme_product_reviews .jdgm-sort-dropdown-label');
      if (sortLabel && sortLabel.textContent !== config.sortBy) sortLabel.textContent = config.sortBy;
      document.querySelectorAll('#judgeme_product_reviews [aria-label], #judgeme_product_reviews img[alt]').forEach((element) => {
        ['aria-label', 'alt'].forEach((attribute) => {
          const current = element.getAttribute(attribute);
          if (!current) return;
          const localized = current
            .replace(/^Average rating is ([\d.]+) stars$/, 'Calificación promedio: $1 de 5 estrellas')
            .replace(/^(\d+)% \((\d+)\) reviews with (\d) star rating$/, '$1% ($2) reseñas de $3 estrellas')
            .replace(/^(\d) star review$/, 'Reseña de $1 estrellas')
            .replace(/^Page (\d+)$/, 'Página $1')
            .replace(/^Verified by Shop$/, 'Verificado por Shop');
          if (localized !== current) element.setAttribute(attribute, localized);
        });
      });
      const countrySelect = document.querySelector('[id$="__17332068787184144230"] .PhoneInputCountrySelect');
      if (countrySelect && typeof Intl.DisplayNames === 'function') {
        countrySelect.setAttribute('aria-label', config.phoneCountry);
        const names = new Intl.DisplayNames(['es'], { type: 'region' });
        Array.from(countrySelect.options).forEach((option) => {
          if (!/^[A-Z]{2}$/.test(option.value)) return;
          const label = option.value === 'ZZ' ? config.international : names.of(option.value);
          if (label && option.textContent !== label) option.textContent = label;
        });
      }
      document.querySelectorAll('#MainContent button[aria-controls]').forEach((button) => {
        if (normalize(button.textContent) !== config.nutritionTitle) return;
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        const inner = panel && panel.querySelector('.collapsible-content__inner');
        if (inner && !inner.hasAttribute('data-esmerally-nutrition')) {
          inner.innerHTML = config.nutritionHtml;
          inner.setAttribute('data-esmerally-nutrition', '');
        }
      });
    }
    document.querySelectorAll(productSelector).forEach((section) => {
      const prepaid = Boolean(section.querySelector('.sls-option-container.sls-active[data-prepaid="true"]'));
      section.classList.toggle('esmerally-prepaid', prepaid);
      const subscription = Boolean(section.querySelector('.sls-option-container.sls-active[data-selling-plan-group]'));
      section.classList.toggle('esmerally-recurring', subscription);
      if (spanish && !section.querySelector('.esmerally-purchase-intro')) {
        const title = section.querySelector('h1, h2');
        if (title) {
          const intro = document.createElement('p');
          intro.className = 'esmerally-purchase-intro';
          const headline = document.createElement('strong');
          headline.textContent = config.introHeadline;
          const description = document.createElement('span');
          description.textContent = config.introText;
          intro.append(headline, description);
          title.insertAdjacentElement('afterend', intro);
        }
      }
      const widget = section.querySelector('.sls-purchase-options-container');
      if (widget && spanish) {
        let note = section.querySelector('.esmerally-purchase-note');
        if (!note) {
          note = document.createElement('p');
          note.className = 'esmerally-purchase-note';
          note.setAttribute('aria-live', 'polite');
          widget.insertAdjacentElement('afterend', note);
        }
        const active = section.querySelector('.sls-option-container.sls-active');
        const recurring = active && active.hasAttribute('data-selling-plan-group');
        const text = prepaid ? config.prepaidNote : recurring ? config.recurringNote : config.oneTimeNote;
        if (note.textContent !== text) note.textContent = text;
      }
      const label = section.querySelector('.product-block--price > .variant__label');
      const labelText = prepaid ? config.prepaidTotal : config.price;
      if (label && label.textContent.trim() !== labelText) label.textContent = labelText;
      if (spanish) {
        const savings = section.querySelector('[data-save-price]');
        if (savings) {
          const amount = savings.textContent.match(/\$[\d,.]+/);
          if (amount && savings.textContent !== config.save + ' ' + amount[0]) savings.textContent = config.save + ' ' + amount[0];
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  };
  const observer = new MutationObserver(schedule);
  ['sealsubs:subscription_widget_created', 'sealsubs:price_update', 'sealsubs:selling_plan_changed'].forEach((eventName) => document.addEventListener(eventName, schedule));
  document.addEventListener('change', (event) => {
    if (event.target.closest(productSelector)) schedule();
  });
  sync();
})();

